import { render, staticRenderFns } from "./Game_pattern_matching.vue?vue&type=template&id=bce91606&style=true"
import script from "./Game_pattern_matching.vue?vue&type=script&lang=js"
export * from "./Game_pattern_matching.vue?vue&type=script&lang=js"
import style0 from "./Game_pattern_matching.vue?vue&type=style&index=0&id=bce91606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports